import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="event-about"
export default class extends Controller {
    static targets = ["addButton", "editButton", "editor", "text", "about", 'aiSummaryButton']

    addAboutText() {
        this.aiSummaryButtonTarget.classList.add('d-none')
        this.textTarget.innerHTML = this.aboutTarget.value
        this._toggleAbout()
    }

    editAbout() {
        this.aiSummaryButtonTarget.classList.remove('d-none')
        this._toggleAbout()
    }

    _toggleAbout() {
        this.editButtonTarget.classList.toggle("d-none")
        this.addButtonTarget.classList.toggle("d-none")
        this.editorTarget.classList.toggle("d-none")
        this.textTarget.classList.toggle("d-none")
    }
}
